import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setCurrentScreen } from "../services/errorHandler";
import analytics from "../services/firebaseAnalytics";

export const ScreenTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const screenName = location.pathname.replace("/", "") || "home";

    // Track for Crashlytics (error context)
    setCurrentScreen(screenName);

    // Firebase Analytics - detailed navigation tracking
    analytics.logScreenView(screenName);
  }, [location]);

  return null;
};
